import { select, Selection, EnterElement, ScaleBand } from "d3"
import { Renderable } from "../../../../Types/Renderable"

export type D3SpectrogramGridLinesConfig = {
	scale: ScaleBand<string>
	tickValues: string[]
	width: number
}

export class D3SpectrogramGridLines implements Renderable {
	private root: SVGGElement
	private config: D3SpectrogramGridLinesConfig

	constructor(root: SVGGElement, config: D3SpectrogramGridLinesConfig) {
		this.root = root
		this.config = config

		const rootNode = select(root)
			.append("g")
			.attr("class", "d3-spectrogram-grid-lines")
			.node()

		if (rootNode != null) {
			this.root = rootNode
		}

		this.render()
	}

	public updateConfig = (config: D3SpectrogramGridLinesConfig): void => {
		this.config = config
		this.render()
	}

	public render = (): void => {
		select(this.root)
			.selectAll("line")
			.data(this.config.tickValues)
			.join(
				newElements => this.enter(newElements),
				updatedElements => this.update(updatedElements),
				exitedElements => exitedElements.remove()
			)
	}

	private enter = (newElements: Selection<EnterElement, string, any, any>): Selection<any, any, any, any> => {
		return newElements
			.append("line")
			.attr("x1", 0)
			.attr("x2", this.config.width)
			.attr("y1", value => this.getY(value))
			.attr("y2", value => this.getY(value))
			.attr("stroke", "var(--color-chart-grid)")
			.attr("stroke-opacity", 0.7)
	}

	private update = (updatedElements: Selection<any, any, any, any>): Selection<any, any, any, any> => {
		return updatedElements
			.attr("x2", this.config.width)
			.attr("y1", value => this.getY(value))
			.attr("y2", value => this.getY(value))
	}

	private getY = (value: string): number => {
		return (this.config.scale(value) ?? 0) + this.config.scale.bandwidth() / 2
	}
}
